module.exports = __webpack_public_path__ + "99e9cd9dd0cd837bab2661aa684b91dd.jpg";